import { useState, type FormEvent } from "react";
import { useAuthStatus, useLogin } from "../hooks/useAuth";
import { ApiError } from "../api/types";

export default function Login() {
  const [password, setPassword] = useState("");
  const login = useLogin();
  const { data: status } = useAuthStatus();

  // Behind Cloudflare Access, Google sign-in happens at the edge before any
  // request reaches the app; landing here means the Access session expired.
  if (status?.mode === "cloudflare") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-bg px-4 text-text">
        <div className="w-full max-w-sm text-center">
          <p className="font-serif text-2xl font-semibold">Boort</p>
          <p className="mt-2 text-sm text-muted">
            Sign-in is handled by Cloudflare Access with your Google account.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="mt-6 rounded-md bg-accent px-5 py-2.5 text-sm font-medium text-white hover:bg-accent-strong"
          >
            Sign in with Google
          </button>
        </div>
      </div>
    );
  }

  function handleSubmit(e: FormEvent) {
    e.preventDefault();
    if (!password) return;
    login.mutate(password);
  }

  const error = login.error instanceof ApiError ? login.error : null;

  return (
    <div className="flex min-h-screen items-center justify-center bg-bg px-4 text-text">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <p className="font-serif text-2xl font-semibold">Boort</p>
          <p className="mt-1 text-sm text-muted">This library is password protected.</p>
        </div>
        <form onSubmit={handleSubmit} className="card-shadow rounded-lg border border-border bg-surface p-6">
          <label htmlFor="password" className="mb-1.5 block text-sm font-medium text-text">
            Password
          </label>
          <input
            id="password"
            type="password"
            autoFocus
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              if (login.isError) login.reset();
            }}
            className="w-full rounded-md border border-border bg-bg px-3 py-2.5 text-text"
            aria-invalid={!!error}
          />
          {error ? <p className="mt-2 text-sm text-danger">{error.message}</p> : null}
          <button
            type="submit"
            disabled={login.isPending || !password}
            className="mt-4 w-full rounded-md bg-accent px-4 py-2.5 text-sm font-medium text-white hover:bg-accent-strong disabled:opacity-50"
          >
            {login.isPending ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
